import { createFileRoute } from '@tanstack/react-router';
import { ShiftsModule } from '@/modules/shifts';

export const Route = createFileRoute('/(dashboard)/_dashboard/approval/shift')({
  component: ShiftsModule,
});
